import { trailFor } from './nav.ts'

/** Breadcrumb labels for the top bar, derived from the sidebar config so the two cannot drift. */
export function routeTrail(pathname: string): string[] {
  return trailFor(pathname.replace(/\/+$/, '') || '/')
}
